import { Box, Typography } from '@mui/material';

import type { DetailsItem as Props } from './interface';

const DetailsItem = ({ label, value }: Props) => (
  <Box>
    <Typography variant="body1">{label}</Typography>
    <Typography variant="body2">{value}</Typography>
  </Box>
);

export default DetailsItem;
